import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, Rocket } from 'lucide-react';
export function Plan48() {
  const steps = [{
    icon: Calendar,
    time: 'Paso 1: Creación con IA',
    desc: 'Le das a la IA nuestras instrucciones exactas y ella escribe tu producto en minutos. Tú solo revisas y apruebas.'
  }, {
    icon: Clock,
    time: 'Paso 2: Diseño Express',
    desc: 'Usas nuestras plantillas y herramientas gratuitas para que tu producto se vea profesional desde tu celular.'
  }, {
    icon: Rocket,
    time: 'Paso 3: Lanzamiento Faceless',
    desc: 'Publicas videos sin mostrar tu cara usando nuestra estrategia y empiezas a recibir mensajes de clientes listos para comprar.'
  }];
  return <section className="bg-white px-4 relative overflow-hidden pt-[36px] pb-[36px] md:pt-[50px] md:pb-[50px]" data-id="element-173">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-16" data-id="element-175">
          <span className="text-primary font-bold uppercase tracking-wider text-sm" data-id="element-176">
            El Método
          </span>
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline mt-2" data-id="element-177">
            Cómo Funciona el Sistema
          </h2>
        </motion.div>

        <div className="relative" data-id="element-178">
          {/* Vertical Line for Desktop */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-stone-200 -translate-x-1/2" data-id="element-179"></div>

          <div className="space-y-12" data-id="element-180">
            {steps.map((step, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.2
          }} className={`flex flex-col md:flex-row items-center gap-8 ${idx % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-181">
                <div className={`flex-1 w-full ${idx % 2 === 0 ? 'md:text-left' : 'md:text-right'}`} data-id="element-182">
                  <div className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary font-bold text-sm mb-4" data-id="element-183">
                    {step.time}
                  </div>
                  <p className="text-xl text-body leading-relaxed font-medium" data-id="element-184">
                    {step.desc}
                  </p>
                </div>

                <div className="flex-shrink-0 w-16 h-16 rounded-full bg-white border border-stone-200 flex items-center justify-center relative z-10 shadow-sm" data-id="element-185">
                  <step.icon className="w-6 h-6 text-primary" data-id="element-186" />
                </div>

                <div className="flex-1 hidden md:block" data-id="element-187"></div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}